// this file contains the logic from the old "app/assets/javascripts/company/company.js"
/* global Swiper */
import { initAccordions } from '../helpers/util'

const removeVideo = () => {
  document.querySelector('.js-modal-content').innerHTML = "";
  document.removeEventListener("afd-modal:close", removeVideo);
}

const updateModalContent = templateId => {
  const template = document.getElementById(templateId);
  const content = template.content.cloneNode(true);

  const modalContent = document.querySelector('.js-modal-content');
  modalContent.innerHTML = "";
  modalContent.append(content);
  document.addEventListener("afd-modal:close", removeVideo);
}

function initToggleButtons () {
  var toggleBtns = document.querySelectorAll('[data-toggle]');
  Array.from(toggleBtns).forEach(function (btn) {
    const { target, toggle, postToggle } = btn.dataset;
    const targetEl = target ? document.querySelector(target) : null;
    if (!targetEl || !toggle) return;

    if (toggle === 'collapse') {
      const visibleItems = +btn.dataset['visibleItems'];
      if (targetEl.children.length <= visibleItems) {
        btn.style.display = 'none';
      }
      Array.from(targetEl.children).forEach((el, idx) => {
        if (idx >= visibleItems) {
          el.classList.add('collapsible');
        }
      })
    }

    btn.addEventListener('click', function (e) {
      switch (toggle) {
        case 'collapse':
          targetEl.classList.toggle('collapsed');
          break;
        case 'modal':
          const { modalContent } = btn.dataset;
          if(modalContent) updateModalContent(modalContent);
          AFD.modals.open('#' + targetEl.id)
          break;
      }
      const { altText } = btn.dataset;
      if (altText) {
        btn.dataset['altText'] = btn.innerText;
        btn.innerText = altText;
      }
      if (postToggle && postToggle === 'destroy') {
        btn.style.display = 'none';
      }
    })
  });
}

function acordeonOneClick(){
  var $category = $('.acordeon__category');
  var companyId = $category.data('company-id');
  var sales = 'sales';
  var branches = 'branches';
  var category = 'account-contact-metrics';

  $category.one('click', function(){
    if($(this).hasClass(sales)) window.adInsights.e(category, 'click', 'sales-contact', companyId);
    if($(this).hasClass(branches)) window.adInsights.e(category, 'click', 'branches', companyId);
  });
}

// Initialize BIM manufacturers carousel
function initializeBIMManufacturersCarousel() {
  var manufacturers = new Swiper('.bim-manufacturers', {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
      nextEl: '.bim-manufacturers__arrow-next',
      prevEl: '.bim-manufacturers__arrow-prev',
    },
    pagination: {
      el: '.bim-manufacturers__bullets',
      dynamicBullets: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true
      }
    }
  });
}

window.onload = acordeonOneClick();

/**
 * Information such as address and phone is hidden at first
 * They only display after being clicked
 */
const companyContactInfoHandler = () => {
  const placeholders = document.querySelectorAll('.companies-info__btn-placeholder')
  placeholders.forEach(el => {
    const realInfo = el.nextElementSibling
    el.addEventListener('click', () => {
      el.style.display = 'none'
      realInfo.classList.remove('companies-info__btn')
    })
  })
}

export const initCompanyPage = () => {
  const companyPage = document.querySelector('.companies-show, .companies-bim_files, .companies-account_files')
  if (!companyPage) return

  initToggleButtons()
  companyContactInfoHandler()
  initAccordions()

  const contactButton = document.querySelector('.account-info-request-btn')
  if (document.body.contains(contactButton)) {
    contactButton.addEventListener('click', function (e) {
      e.preventDefault();
      AFD.modals.open('#modal-account-info-request')
    });
  }

  initializeBIMManufacturersCarousel()
};